import { render, staticRenderFns } from "./paper-manage.vue?vue&type=template&id=89db2354&scoped=true"
import script from "./paper-manage.vue?vue&type=script&lang=js"
export * from "./paper-manage.vue?vue&type=script&lang=js"
import style0 from "./paper-manage.vue?vue&type=style&index=0&id=89db2354&prod&lang=less&scoped=true"
import style1 from "./paper-manage.vue?vue&type=style&index=1&id=89db2354&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89db2354",
  null
  
)

export default component.exports